<template>
  <div class="btn-group">   <!-- 白色： secondary 、紫色： primary 、绿色： success 、蓝色： info 、黄色： warning  -->
    <label :style="{width: parseInt(width) + 'px'}"
           :class="[vals === item.id ? 'active' : '',  'btn-' + backColor]" 
           class="btn btn-outline" 
           v-for="(item, index) in data" 
           :key="index">
      <div>
        <input :checked="vals === item.id" @click="change(item)" type="radio" :name="name">
        <i class="ti-check text-active"></i>
        {{item.label}}
      </div>
    </label>
  </div>
</template>



<script>
  export default {
    name: 'radio-group',
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      width: {
        type: [String, Number],
        default: ''
      },
      backColor: {
        type: String,
        default: 'info'
      },
      name: {
        type: String,
        default: ''
      },
      data: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        vals: this.value
      }
    },
    methods: {
      change (data) {
        this.vals = data.id
        this.$emit('change', data)
      }
    }
  }
</script>

<style lang='scss' scoped>
  .btn-secondary:hover {
    color: #fff !important;
  }
  .btn-group label.btn-secondary.active {
    color: #ffffff !important;
  }
  .btn-group label>div{
    overflow: hidden;
  }
  .filter_but {
    padding: 0.375rem 0.75rem;
    transition: 0.2s ease-in;
  }
  .btn-primary.active, .btn-primary.disabled.active, .btn-primary.disabled:active, .btn-primary.disabled:focus, .btn-primary:active, .btn-primary:focus{
    background: #6352ce !important;
    border-color: #6352ce !important;
    box-shadow: 0 14px 26px -12px rgba(116, 96, 238, 0.42), 0 4px 23px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(116, 96, 238, 0.2);
  }
  .btn-success.active, .btn-success.disabled.active, .btn-success.disabled:active, .btn-success.disabled:focus, .btn-success:active, .btn-success:focus {
    background: #1eacbe !important;
    border-color: #1eacbe !important;
    -webkit-box-shadow: 0 14px 26px -12px rgba(40, 190, 189, 0.42), 0 4px 23px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(40, 190, 189, 0.2);
    box-shadow: 0 14px 26px -12px rgba(40, 190, 189, 0.42), 0 4px 23px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(40, 190, 189, 0.2);
  }
  .btn-info.active{
    background: #028ee1 !important;
    border-color: #028ee1 !important;
    -webkit-box-shadow: 0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2);
    box-shadow: 0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2);
  }
  [type=radio]:checked + .text-active {
    // display: inline;
  }
  .btn-link, .btn-link:focus, .btn-link:hover{
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/radio-group/radio-group.vue